/**
 * PrivacyBadge — surfaces ZEASTRO's in-house AI privacy advantage
 * at every data-collection touchpoint (birth chart, kundali, chat).
 */
export default function PrivacyBadge({
  className = "",
  compact = false,
}: {
  className?: string;
  /** Slim single-line variant for tight chat composers. */
  compact?: boolean;
}) {
  return (
    <div
      className={`flex items-center gap-2 text-emerald-600 dark:text-emerald-400 ${
        compact
          ? "justify-center text-[10px] leading-tight"
          : "rounded-lg border border-emerald-500/25 bg-emerald-500/8 px-3 py-2 text-xs"
      } ${className}`}
      data-no-translate
    >
      <svg
        className="h-3.5 w-3.5 shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
      <span>
        <span className="font-semibold">Your data never leaves ZEASTRO.</span>{" "}
        {compact
          ? "Private in-house AI — no third parties."
          : "Powered by our private in-house AI — not OpenAI, Google, or any third party."}
      </span>
    </div>
  );
}
